<div class="pt-2" [formGroup]="formGroup">
  <dgx-dfb-checkbox
    [field]="field"
    [formControlName]="field.controlName"
    [validate]="validateField"
  >
  </dgx-dfb-checkbox>
</div>
